import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  categories: [],
  isLoaded: false,
  isSavingActive: false,
}

const arcCategoriesSlice = createSlice({
  name: 'arcCategories',
  initialState,
  reducers: {
    fetchArcCategoriesSuccess: (state, { payload }) => ({
      ...state,
      isLoaded: true,
      categories: payload.categories,
    }),
    fetchArcCategoriesFailure: (state) => ({
      ...state,
      isLoaded: false,
      categories: [],
    }),
    startSaving: (state) => ({
      ...state,
      isSavingActive: true,
    }),
    finishSaving: (state) => ({
      ...state,
      isSavingActive: false,
    }),
    clearData: () => initialState,
  },
})

export const { actions } = arcCategoriesSlice
export default arcCategoriesSlice